module.exports = __webpack_public_path__ + "media/images/line-horiz-742a8fa16f85c18b6166c1c71f9636f5.svg";